import Colors from "../../../theme/colors";

const style = {
  container: {
    color: Colors.white,
  },
  tableHeadCell: {
    p: 1,
    fontSize: 12,
    backgroundColor: Colors.darkBlue,
    border: "none",
    color: Colors.white,
    fontWeight: 700,
    paddingLeft: 4,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  tableBody: {
    backgroundColor: Colors.white,
    border: "none",
    color: Colors.white,
  },
  emptyList: {
    display: "flex",
    justifyContent: "center",
    padding: "1rem",
    width: "100%",
  },
};

export default style;
